<template>
  <main>
    <section class="video-intro">
      <h1>Contrology Event Video</h1>
    </section>

    <nav>
      <router-link to="event-videos" title="See all event videos"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">all videos</router-link>
    </nav>

    <div class="video-container">
      <iframe title="This is an embedded iframe video" width="996" height="560" src="https://www.youtube.com/embed/6FPIsp84caU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="wide-flex-wrapper">
      <section class="video-description">
        <h2>Contrology Poland: Classical Pilates Discovery</h2>
        <p>Original Air Date: July 25, 2020</p>
        <p>Join some of the great classical teachers in Poland for this invigorating exploration into the Contrology Apparatus Suite. Hosted by our Polish distributor, Waldermar Cieslak, and featuring all-star instructors Jacqueline Martin, Mariola Wentlandt, Weronika Ratkowska, and Karolina Libelt, this entrant into the Contrology streaming series features packs in:</p>
        <ol>
          <li>Opening remarks from Waldermar and special guests Pilates legend Jay Grimes and Balanced Body CEO, Ken Endelman</li>
          <li>30 minute classical mat workout #1</li>
          <li>30 minute classical mat workout #1</li>
          <li>40 minute Contrology Apparatus Suite Workout featuring the Contrology Reformer, Cadillac, Pedo-Pul and Arm Chair</li>
          <li>Q and A with Waldemar, Jay and Ken</li>
        </ol>
        <p>Workouts are in Polish. Q &amp; A is in English.</p>
        <p>Runtime:  100 minutes (Workouts), 168 minutes total</p>
      </section>

      <hr>

      <section class="video-speakers">
        <h3>Featured Speakers</h3>
        <div class="video-speakers-container">
          <div class="video-speaker">
            <img src="@/assets/jacqueline-martin@1x.jpg" srcset="@/assets/jacqueline-martin@2x.jpg 2x" alt="Jacqueline headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Jacqueline Martin</b></p>
              <p><a href="https://pilateslineage.com/">Lineage Pilates</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/mariola-wentlandt@1x.jpg" srcset="@/assets/mariola-wentlandt@2x.jpg 2x" alt="Mariola headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Mariola Wentlandt</b></p>
              <p style="white-space:nowrap"><a href="http://www.pilateslublin.pl/">KLASYCZNY PILATES</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/weronika-ratkowska@1x.jpg" srcset="@/assets/weronika-ratkowska@2x.jpg 2x" alt="Weronika headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Weronika Ratkowska</b></p>
              <p><a href="http://www.pilatesroom.pl/">Pilates Room</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/karolina-libelt@1x.jpg" srcset="@/assets/karolina-libelt@2x.jpg 2x" alt="Karolina headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Karolina Libelt</b></p>
              <p><a href="http://www.kl-pilates.com/">Libelt Pilates</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
    
  </main>
</template>

<script>
  export default {
    name: "videodiscovery",

    metaInfo: {
      title: "Classical Pilates Contrology Poland - Polish Pilates Workshop",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Enjoy this online Classical Pilates Workshop in Poland featuring the Contrology Apparatus Suite. Workshops are in Polish with Q & A in English with legend Jay Grimes."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/videodiscovery.jpg"
        }
      ]
    },
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 996px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

nav img {
  margin-right: 15px;
}

.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
  max-width: 996px;
  margin: 0 auto 40px;
}

.video-container iframe,
.video-container object,
.video-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  max-height: 560px;
}

.video-description p {
  font-size: 0.9375rem;
  line-height: 1.4667;
}

hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin: 30px 0;
}

h3 {
  text-align: left;
}

.video-speakers {
  width: 275px;
  margin: 0 auto;
}

.video-speaker {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.video-speaker img {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 12px;
}

.video-speaker-content p {
  margin: 0 0 10px 0;
}

.video-speaker-content p a {
  color: #000;
}

ol li {
  margin: 10px 0;
}

@media only screen and (max-width:374px) {
  .video-speakers {
    width: 250px;
    margin: -10px
  }
}

@media only screen and (min-width:800px) {
  .video-intro {
    margin: 0 auto;
  }

  .wide-flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  hr {
    display: none;
  }

  .video-description {
    margin-right: 40px;
  }
}

@media only screen and (min-width:955px) {
  .video-intro {
    max-width: 650px;
  }
}

@media only screen and (min-width:1080px) {
  .video-container { 
    padding-bottom: 0;
    height: 560px;
  }
}
</style>